export enum UserType {
  DIV = 'division',
  Status = 'active',
  ID = 'id',
  FirstName = 'firstName',
  LastName = 'lastName'
}
